<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';

export default {
  name: 'ProductionItem',
  props: ['produto'],
  components: {
    Swiper,
    SwiperSlide,
  },
  computed: {
    orderedImages() {
      if (!this.produto?.imagens?.length) {
        return [];
      }

      const principalIndex = this.produto.imagens.findIndex(
        (img) => img.caminho === this.produto.caminho,
      );

      if (principalIndex <= 0) {
        return this.produto.imagens;
      }

      const images = this.produto.imagens.slice();
      const [principalImage] = images.splice(principalIndex, 1);
      images.unshift(principalImage);
      return images;
    },
  },
  data() {
    return {
      readyToShowSwiper: false,
      swiperOptions: {
        loop: true,
        loopedSlides: 5,
        spaceBetween: 10,
        slidesPerView: 1,
        centeredSlides: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
      swiperOptionThumbs: {
        loop: true,
        loopedSlides: 5, // looped slides should be the same
        spaceBetween: 10,
        centeredSlides: true,
        slidesPerView: 4,
        touchRatio: 0.2,
        slideToClickedSlide: true,
      },
    };
  },
  methods: {
    onCheckItem() {
      if (this.$store.state.InfoPedido.selectedItem !== this.produto) {
        this.$store.commit('InfoPedido/SET_ITEM_SELECTED', this.produto);
        this.$root.$emit('infoPedido:checkGrade');
      }
    },
  },
  mounted() {
    setTimeout(() => {
      this.readyToShowSwiper = true;
      this.$nextTick(() => {
        if (this.$refs.refSwiperTop) {
          const refSwiperTop = this.$refs.refSwiperTop.$swiper;
          const swiperThumbs = this.$refs.swiperThumbs.$swiper;
          refSwiperTop.controller.control = swiperThumbs;
          swiperThumbs.controller.control = refSwiperTop;
        }
      });
    }, 10);
  },
};
</script>

<template>
  <b-card no-body style="border: 0.1rem solid gray;">

    <swiper
        v-if="readyToShowSwiper"
        ref="refSwiperTop"
        class="swiper-gallery gallery-top cursor-pointer"
        :options="swiperOptions"
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
        :navigation="true"
        @click="onCheckItem"
    >
      <swiper-slide
          v-for="(data,index) in orderedImages"
          :key="index"
          class="swiper-slide-top"

      >
        <b-img
            :src="data.caminho"
            fluid
            loading="lazy"
            class="swiper-image principal"
        />
      </swiper-slide>
    </swiper>
    <div
        class="text-bold cursor-pointer"
        @click="onCheckItem"
    >
      <h4
          id="description-item"
          class="font-weight-bold text-center my-1"
          style="font-size: 1.0rem"
      >{{produto.Descricao}}</h4>
      <div v-if="false" class="badge badge-danger">20% OFF</div>
    </div>
    <swiper
        ref="swiperThumbs"
        class="swiper gallery-thumbs my-1 bg-red"
        :options="swiperOptionThumbs"
    >
      <swiper-slide
          v-for="(data,index) in orderedImages"
          :key="index"
          class="swiper-slide-thumbs cursor-pointer"
      >
        <b-img
            :src="data.caminho"
            fluid
            loading="lazy"
            class="bg-cover swiper-image"
        />
      </swiper-slide>
    </swiper>
  </b-card>
</template>

<style scoped lang="scss">
.swiper-slide-top {
  border-radius: 10px;
  overflow: hidden;
}

.swiper-slide-thumbs {
  border: 2px solid transparent;
  transition: border-color 0.3s ease;
}

#description-item:hover {
  color: var(--primary);
}
.swiper-slide-thumbs.selected {
  border-color: blue;
}

.swiper-image {
  width: 100%;
  object-fit: cover;
  height: 65px;
}

.swiper-image.principal {
  height: 100%;
  width: 100%;
  object-fit: cover;
  max-height: 280px;
  transition: transform 0.3s ease, opacity 0.3s ease, box-shadow 0.3s ease;
}
.swiper-image.principal:hover {
  opacity: 0.9;
  transform: scale(1.05);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
}
.swiper-slide-thumbs.swiper-slide:not(.swiper-slide-active) {
  opacity: 0.3;
  transition: opacity 0.3s ease;
}
.swiper-slide-thumbs.swiper-slide-active {
  border: 2px solid var(--primary);
}
.badge {
  position: absolute;
  top: 10px;
  right: 10px;
  padding: 5px 10px;
  font-size: 0.8rem;
  z-index: 999;
}
</style>
